/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Używamy plików cookie wyłącznie w celu śledzenia odwiedzin na naszej stronie internetowej, nie przechowujemy żadnych danych osobowych.',
    cookiesAccept: 'Akceptuj pliki cookie',
    cookiesDeny: 'Odrzuć pliki cookie',
    tabFAQs: 'Często zadawane pytania',
    tabSupport: 'Wsparcie',
    tabHistory: 'Historia',
    tabReviews: 'Historie',
    // tabTraining: 'Szkolenie',
    // tabHcpTraining: '',
    tabTraining: 'Szkolenie',
    tabUserTraining: 'Szkolenie użytkowników',
    tabHcpTraining: 'Szkolenie medyczne',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Ciąża',
    tabAbout: 'O nas',
    tabNews: 'Aktualności',
    tabCareers: 'Kariera',
    tabOrders: '',
    tabNotifications: 'Powiadomienia',
};
